import React, { useState, useEffect } from 'react';
import { TIPOS_PROYECTO } from '../data/proyectos';
import { leerProyectosSheets, leerEntregablesSheets } from '../services/claudeApi';

export default function Tracker({ proyectoActivo: proyectoInit, setProyectoActivo }) {
  const [proyectos, setProyectos] = useState([]);
  const [proyectoSel, setProyectoSel] = useState(proyectoInit || null);
  const [tab, setTab] = useState('fases');
  const [checks, setChecks] = useState({});
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    leerProyectosSheets()
      .then(data => {
        setProyectos(data);
        setCargando(false);
      })
      .catch(err => {
        console.error('Error leyendo Sheets:', err);
        setCargando(false);
      });
  }, []);

  const seleccionar = (p) => { setProyectoSel(p); setProyectoActivo(p); setTab('fases'); };
  const tipoDatos = proyectoSel ? TIPOS_PROYECTO.find(t => t.id === proyectoSel.tipo) : null;
  const toggleCheck = (id) => setChecks(prev => ({ ...prev, [id]: !prev[id] }));
  const checklistItems = tipoDatos?.checklist || [];
  const completados = checklistItems.filter(c => checks[c.id]).length;
  const categorias = [...new Set(checklistItems.map(c => c.categoria))];

  return (
    <div style={{ display: 'flex', gap: 24, height: 'calc(100vh - 80px)' }}>
      <div style={{ width: 280, flexShrink: 0, overflowY: 'auto' }}>
        <div style={{ marginBottom: 16 }}>
          <h1 className="page-title" style={{ fontSize: 18 }}>Proyectos</h1>
          <p className="page-subtitle">{proyectos.length} proyectos</p>
        </div>
        {cargando && <div style={{ color: '#A8B5C2', fontSize: 13, padding: 12 }}>Cargando...</div>}
        {!cargando && proyectos.length === 0 && (
          <div style={{ textAlign: 'center', padding: 24, color: '#A8B5C2' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📁</div>
            <p style={{ fontSize: 13 }}>No hay proyectos aún</p>
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {proyectos.map(p => {
            const tipo = TIPOS_PROYECTO.find(t => t.id === p.tipo);
            return (
              <div key={p.id} onClick={() => seleccionar(p)} style={{
                background: proyectoSel?.id === p.id ? '#FFF7F0' : 'white',
                border: `1.5px solid ${proyectoSel?.id === p.id ? '#E8863A' : '#E8ECF0'}`,
                borderRadius: 10, padding: '12px 14px', cursor: 'pointer'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span>{tipo?.icono || '📁'}</span>
                  <span style={{ fontWeight: 500, fontSize: 13, color: '#1A2E44', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.nombre}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className={`badge badge-${(p.estado||'propuesta').toLowerCase().replace(' ','')}`} style={{ fontSize: 10 }}>{p.estado||'Propuesta'}</span>
                  <span style={{ fontSize: 11, color: '#6B7A89' }}>{p.avance||0}%</span>
                </div>
                <div className="progress-bar" style={{ marginTop: 8 }}>
                  <div className="progress-fill" style={{ width: `${p.avance||0}%` }}></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {!proyectoSel ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', color: '#A8B5C2' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>📁</div>
              <p>Selecciona un proyecto para ver el detalle</p>
            </div>
          </div>
        ) : (
          <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <div className="card" style={{ marginBottom: 16, flexShrink: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                    <span style={{ fontSize: 24 }}>{tipoDatos?.icono || '📁'}</span>
                    <h2 style={{ fontSize: 18, fontWeight: 600, color: '#1A2E44' }}>{proyectoSel.nombre}</h2>
                    <span className={`badge badge-${(proyectoSel.estado||'propuesta').toLowerCase().replace(' ','')}`}>{proyectoSel.estado}</span>
                  </div>
                  <p style={{ color: '#6B7A89', fontSize: 13 }}>{proyectoSel.descripcion || 'Sin descripción'}</p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 28, fontWeight: 700, color: '#1A2E44' }}>{proyectoSel.avance||0}%</div>
                  <div style={{ fontSize: 11, color: '#6B7A89' }}>Avance</div>
                </div>
              </div>
              <div className="progress-bar" style={{ marginTop: 12, height: 8 }}>
                <div className="progress-fill" style={{ width: `${proyectoSel.avance||0}%` }}></div>
              </div>
              <div style={{ display: 'flex', gap: 24, marginTop: 14, flexWrap: 'wrap' }}>
                {[
                  { label: 'Cliente', val: proyectoSel.cliente },
                  { label: 'Responsable', val: proyectoSel.responsable },
                  { label: 'Presupuesto', val: proyectoSel.costo_presupuesto ? `$${Number(proyectoSel.costo_presupuesto).toLocaleString()}` : 'Por definir' },
                ].map(item => (
                  <div key={item.label}>
                    <div style={{ fontSize: 10, color: '#A8B5C2', textTransform: 'uppercase', marginBottom: 2 }}>{item.label}</div>
                    <div style={{ fontSize: 13, fontWeight: 500, color: '#2C3E50' }}>{item.val || '—'}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="tabs" style={{ flexShrink: 0 }}>
              <button className={`tab-btn ${tab === 'fases' ? 'active' : ''}`} onClick={() => setTab('fases')}>Fases</button>
              <button className={`tab-btn ${tab === 'checklist' ? 'active' : ''}`} onClick={() => setTab('checklist')}>Checklist ({completados}/{checklistItems.length})</button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', paddingBottom: 20 }}>
              {tab === 'fases' && tipoDatos && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {tipoDatos.fases.map((fase, fi) => (
                    <div key={fase.codigo} className="card" style={{ padding: '14px 18px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                        <div style={{ width: 28, height: 28, borderRadius: 6, background: '#F4F6F8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: '#A8B5C2' }}>{fi+1}</div>
                        <div style={{ fontWeight: 600, fontSize: 13.5, color: '#1A2E44' }}>{fase.codigo} — {fase.nombre}</div>
                      </div>
                      <div style={{ marginLeft: 38, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                        {fase.procesos.map(proc => (
                          <span key={proc} style={{ background: '#F4F6F8', color: '#6B7A89', padding: '2px 10px', borderRadius: 20, fontSize: 11.5 }}>{proc}</span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {tab === 'fases' && !tipoDatos && (
                <div style={{ textAlign: 'center', padding: 40, color: '#A8B5C2' }}>Tipo de proyecto no definido.</div>
              )}
              {tab === 'checklist' && tipoDatos && (
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, padding: '10px 14px', background: '#F4F6F8', borderRadius: 8 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#1A2E44', marginBottom: 4 }}>Progreso del checklist</div>
                      <div className="progress-bar" style={{ height: 8 }}>
                        <div className="progress-fill" style={{ width: `${checklistItems.length > 0 ? (completados/checklistItems.length)*100 : 0}%`, background: completados === checklistItems.length ? '#22C55E' : '#E8863A' }}></div>
                      </div>
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#1A2E44' }}>{completados}/{checklistItems.length}</div>
                  </div>
                  {categorias.map(cat => (
                    <div key={cat} style={{ marginBottom: 16 }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#E8863A', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6, paddingLeft: 12 }}>{cat}</div>
                      {checklistItems.filter(c => c.categoria === cat).map(item => (
                        <div key={item.id} className={`checklist-item ${checks[item.id] ? 'done' : ''}`} onClick={() => toggleCheck(item.id)}>
                          <div className={`checklist-check ${checks[item.id] ? 'checked' : ''}`}>
                            {checks[item.id] && <span style={{ color: 'white', fontSize: 11, fontWeight: 700 }}>✓</span>}
                          </div>
                          <div className="checklist-text">{item.texto}</div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
              {tab === 'checklist' && !tipoDatos && (
                <div style={{ textAlign: 'center', padding: 40, color: '#A8B5C2' }}>Tipo de proyecto no definido.</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}